import React, { useState } from "react";
import axios from "axios";
import "./ContributeModal.css";

export default function ContributeModal({ track, phases, onClose }) {
  const [formData, setFormData] = useState({
    phaseId: "",
    newTopicName: "",
    resourceTitle: "",
    resourceUrl: "",
    resourceType: "video",
    description: "",
    suggestionIdea: ""
  });
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${process.env.REACT_APP_API_URL || "/api"}/tracks/${track.slug}/contribute`, {
        trackId: track._id,
        phaseId: formData.phaseId === "new" ? null : formData.phaseId,
        newTopicName: formData.phaseId === "new" ? formData.newTopicName : null,
        resourceData: {
          title: formData.resourceTitle,
          url: formData.resourceUrl,
          type: formData.resourceType,
          description: formData.description
        },
        suggestionIdea: formData.suggestionIdea
      }, { withCredentials: true });

      setStatus("success");
    } catch (err) {
      console.error("Contribute error:", err);
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div className="contribute-modal-overlay">
        <div className="contribute-modal success-state">
          <div className="success-icon">🎉</div>
          <h2>Thank You, Contributor!</h2>
          <p>Your resource suggestion for <strong>{track.title}</strong> has been submitted. Our team will review it shortly. If approved, you'll earn 150 XP and 20 Credits!</p>
          <button className="modal-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="contribute-modal-overlay">
      <div className="contribute-modal">
        <div className="modal-header">
          <h3>🚀 Contribute to {track.title}</h3>
          <button className="close-x" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="contribute-form">
          <div className="form-group">
            <label>Where does this fit?</label>
            <select name="phaseId" value={formData.phaseId} onChange={handleChange} required>
              <option value="">Select Topic/Phase</option>
              {phases.map(p => (
                <option key={p._id} value={p._id}>{p.title}</option>
              ))}
              <option value="new">+ Suggest New Topic</option>
            </select>
          </div>

          {formData.phaseId === "new" && (
            <div className="form-group animate-in">
              <label>Topic Name</label>
              <input 
                type="text" 
                name="newTopicName" 
                placeholder="e.g. Advanced State Management" 
                value={formData.newTopicName} 
                onChange={handleChange} 
                required 
              />
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Resource Title</label>
              <input 
                type="text" 
                name="resourceTitle" 
                placeholder="Name of the video/article" 
                value={formData.resourceTitle} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="form-group">
              <label>Type</label>
              <select name="resourceType" value={formData.resourceType} onChange={handleChange}>
                <option value="video">Video (YouTube)</option>
                <option value="article">Article/Blog</option>
                <option value="docs">Official Docs</option>
                <option value="pdf">PDF/Guide</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Resource URL</label>
            <input 
              type="url" 
              name="resourceUrl" 
              placeholder="https://youtube.com/watch?v=..." 
              value={formData.resourceUrl} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label>Why is this a high-quality resource?</label>
            <textarea 
              name="suggestionIdea" 
              placeholder="Tell us what makes this special..." 
              rows="3" 
              value={formData.suggestionIdea} 
              onChange={handleChange} 
              required
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="submit-btn" disabled={status === "loading"}>
              {status === "loading" ? "Submitting..." : "Submit Contribution"}
            </button>
          </div>
          {status === "error" && <p className="error-msg">Ops! Something went wrong. Please try again.</p>}
        </form>
      </div>
    </div>
  );
}
